import { useIntl } from '@umijs/max';
import { RuleObject } from 'antd/lib/form';
import { isEmail, isMobilePhone } from 'class-validator';
import { useMemo } from 'react';

export type ValidatorOption = {
  max?: number;
  min?: number;
  minMessage?: string;
  maxMessage?: string;
  phoneMessage?: string;
  emailMessage?: string;
  requiredMessage?: string;
  fullMessage?: string;
};

export const useValidator = (options?: ValidatorOption) => {
  const intl = useIntl();

  return useMemo(
    () => ({
      phone: (opts?: Pick<ValidatorOption, 'phoneMessage'>) => ({
        validator: async (rule: RuleObject, value: any): Promise<void> => {
          if (value && !isMobilePhone(value)) {
            throw new Error(
              opts?.phoneMessage ??
                options?.phoneMessage ??
                intl.formatMessage({
                  id: 'validations.mobile_phone_incorrect',
                  defaultMessage: 'Số điện thoại không đúng định dạng',
                }),
            );
          }
        },
      }),
      email: (
        opts?: Pick<ValidatorOption, 'emailMessage'> | null,
        tranform: (value?: any) => any = (value) => value,
      ) => ({
        validator: async (rule: RuleObject, value: any): Promise<void> => {
          const tranformValue = tranform(value);

          if (tranformValue && !isEmail(tranformValue)) {
            throw new Error(
              opts?.emailMessage ??
                options?.emailMessage ??
                intl.formatMessage({
                  id: 'validations.email_inccorect',
                  defaultMessage: 'Email không đúng định dạng',
                }),
            );
          }
        },
      }),
      selectRequired: (
        opts?: Pick<ValidatorOption, 'requiredMessage'> | null,
        tranform: (value?: any) => any = (value) => value,
      ) => ({
        required: true,
        validator: async (rule: RuleObject, value: any): Promise<void> => {
          const tranformValue = tranform(value);

          if (!tranformValue || (tranformValue && !tranformValue.value)) {
            throw new Error(
              opts?.requiredMessage ??
                options?.requiredMessage ??
                intl.formatMessage({
                  id: 'validations.required',
                  defaultMessage: 'Bắt buộc',
                }),
            );
          }
        },
      }),
      required: (opts?: Pick<ValidatorOption, 'requiredMessage'>) => ({
        required: true,
        message:
          opts?.requiredMessage ??
          options?.requiredMessage ??
          intl.formatMessage({
            id: 'validations.required',
            defaultMessage: 'Bắt buộc',
          }),
      }),
      max: (opts?: Pick<ValidatorOption, 'max' | 'maxMessage'>) => ({
        max: opts?.max ?? options?.max,
        message:
          opts?.maxMessage ??
          options?.maxMessage ??
          intl.formatMessage(
            {
              id: 'validations.max',
              defaultMessage: 'Độ dài tối đa: {max} ký tự',
            },
            {
              max: opts?.max ?? options?.max,
            },
          ),
      }),
      min: (opts?: Pick<ValidatorOption, 'min' | 'minMessage'>) => ({
        min: opts?.min ?? options?.min,
        message:
          opts?.minMessage ??
          options?.minMessage ??
          intl.formatMessage(
            {
              id: 'validations.min',
              defaultMessage: 'Độ dài tối thiểu: {min} ký tự',
            },
            {
              min: opts?.min ?? options?.min,
            },
          ),
      }),
    }),
    [intl.locale, options],
  );
};
